(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('layoutTemplateComponentItem', {
            templateUrl: 'app/admin/showcase-layout-template/components/layout-template-component-item/layout-template-component-item.html',
            bindings: {
                component: '=',
                categories: '<',
                columnIndex: '<',
                columnCount: '<',
                onMove: '&',
                onRemove: '&',
                onEdit: '&'
            },
            controller: LayoutTemplateComponentItemController
        });

    LayoutTemplateComponentItemController.$inject = ['$translate'];

    function LayoutTemplateComponentItemController($translate) {
        var vm = this;
        var MAX_VISIBLE_CHIPS = 3;
        var GENDER_LABEL_KEYS = {
            1: 'flyers.new.form.gender.male',
            2: 'flyers.new.form.gender.female',
            3: 'flyers.new.form.gender.both'
        };

        vm.getBannerCount = getBannerCount;
        vm.getFirstBannerCover = getFirstBannerCover;
        vm.getFirstBannerName = getFirstBannerName;
        vm.isProductComponent = isProductComponent;
        vm.isBrandComponent = isBrandComponent;
        vm.hasProductFilters = hasProductFilters;
        vm.getVisibleProductFilterChips = getVisibleProductFilterChips;
        vm.getProductFilterOverflowCount = getProductFilterOverflowCount;
        vm.canMoveLeft = canMoveLeft;
        vm.canMoveRight = canMoveRight;
        vm.showMove = showMove;
        vm.moveLeft = moveLeft;
        vm.moveRight = moveRight;

        function showMove() {
            return (vm.columnCount || 1) > 1;
        }

        function canMoveLeft() {
            return showMove() && vm.columnIndex > 0;
        }

        function canMoveRight() {
            return showMove() && vm.columnIndex < vm.columnCount - 1;
        }

        function moveLeft($event) {
            if ($event) {
                $event.stopPropagation();
            }
            if (!canMoveLeft()) {
                return;
            }
            vm.onMove({ direction: -1 });
        }

        function moveRight($event) {
            if ($event) {
                $event.stopPropagation();
            }
            if (!canMoveRight()) {
                return;
            }
            vm.onMove({ direction: 1 });
        }

        function getBannerIds() {
            if (!vm.component) {
                return [];
            }
            if (vm.component.parsedValue && vm.component.parsedValue.bannerIds) {
                return vm.component.parsedValue.bannerIds;
            }
            return [];
        }

        function getBannerCount() {
            return getBannerIds().length;
        }

        function getFirstBanner() {
            if (!vm.component || vm.component.componentKey !== 'BANNER_CAROUSEL') {
                return null;
            }
            if (vm.component.banners && vm.component.banners.length) {
                return vm.component.banners[0];
            }
            return null;
        }

        function getFirstBannerCover() {
            var banner = getFirstBanner();
            return banner && banner.cover ? banner.cover : null;
        }

        function getFirstBannerName() {
            var banner = getFirstBanner();
            return banner && banner.name ? banner.name : '';
        }

        function isProductComponent() {
            return !!(vm.component && vm.component.componentKey &&
                vm.component.componentKey.indexOf('PRODUCTS') === 0);
        }

        function isBrandComponent() {
            return !!(vm.component && vm.component.componentKey &&
                vm.component.componentKey.indexOf('BRANDS') === 0);
        }

        function getProductFilterChips() {
            if (!isProductComponent()) {
                return [];
            }

            var value = vm.component.parsedValue || {};
            var chips = [];

            if (value.isLaunch) {
                chips.push($translate.instant('showcase-layout-template.filters.isLaunch'));
            }
            if (value.isBasic) {
                chips.push($translate.instant('showcase-layout-template.filters.isBasic'));
            }

            (value.categoryKeys || []).forEach(function (key) {
                chips.push(resolveCategoryLabel(key));
            });

            (value.brands || []).forEach(function (brand) {
                var brandLabel = typeof brand === 'string'
                    ? brand
                    : (brand && (brand.name || brand.label || brand.value));
                if (brandLabel) {
                    chips.push(brandLabel);
                }
            });

            if (value.gender !== null && value.gender !== undefined && value.gender !== '') {
                chips.push(resolveGenderLabel(value.gender));
            }

            return chips;
        }

        function hasProductFilters() {
            return getProductFilterChips().length > 0;
        }

        function getVisibleProductFilterChips() {
            return getProductFilterChips().slice(0, MAX_VISIBLE_CHIPS);
        }

        function getProductFilterOverflowCount() {
            return Math.max(0, getProductFilterChips().length - MAX_VISIBLE_CHIPS);
        }

        function resolveCategoryLabel(key) {
            var match = (vm.categories || []).find(function (category) {
                return category.key === key || category.value === key || category.id === key;
            });
            return (match && (match.title || match.label || match.name)) || key;
        }

        function resolveGenderLabel(gender) {
            var labelKey = GENDER_LABEL_KEYS[parseInt(gender, 10)];
            return labelKey ? $translate.instant(labelKey) : String(gender);
        }
    }
})();
